import { useState } from "react";
import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/dm.png";
import Architecture from "./../../assets/images/banner/Architecture.png";
import workflow from "./../../assets/images/banner/WhatsApp_Marketing_Workflow.png";
// import Brochures from "./../../assets/images/WA_idc.png";
// import { Link } from "react-router-dom";

const resultsData = [
  {
    metric: "AI WhatsApp marketing",
    before: "Marketing messages handled manually",
    after: "Targeted WhatsApp messages sent to opted-in customers",
  },
  {
    metric: "WhatsApp marketing dashboard",
    before: "Customer replies hard to track",
    after: "Track replies, message status, promotions, and leads",
  },
  {
    metric: "Meta comment automation",
    before: "Comments checked manually",
    after: "Bot replies automatically to comments",
  },
  {
    metric: "DM to AI WhatsApp",
    before: "Interested users drop off",
    after: "DM guides customers to AI WhatsApp chatbot",
  },
  {
    metric: "AI WhatsApp chatbot conversion",
    before: "Staff reply delayed",
    after: "AI replies instantly and collects enquiries",
  },
  {
    metric: "Meta Ads to WhatsApp leads",
    before: "Limited organic reach",
    after: "Ads bring more customers into WhatsApp",
  },
];

const featureCards = [
  {
    icon: "bi bi-whatsapp",
    title: "AI WhatsApp Marketing",
    desc: "Send targeted WhatsApp promotional messages, updates, and offers to opted-in customers in a structured and controlled way.",
  },
  {
    icon: "bi bi-bar-chart-fill",
    title: "AI WhatsApp Marketing Dashboard",
    desc: "Track customer replies, message status, promotion usage, and lead movement from a single dashboard.",
  },
  {
    icon: "bi bi-chat-dots-fill",
    title: "Automatic Meta Comment Reply",
    desc: "Automatically reply to comments on Instagram and Facebook reels or posts using predefined bot responses.",
  },
  {
    icon: "bi bi-send-fill",
    title: "Automatic DM to AI WhatsApp Chatbot",
    desc: "Send automatic direct messages to interested customers and guide them from Instagram or Facebook into the AI WhatsApp chatbot.",
  },
  {
    icon: "bi bi-megaphone-fill",
    title: "Meta Ads to AI WhatsApp Setup",
    desc: "Run Meta Ads through Instagram reels, Facebook posts, and marketing creatives to increase reach and bring more leads into the AI WhatsApp chatbot.",
  },
];
const faqs = [
  {
    q: "Can this solution send WhatsApp marketing messages?",
    a: "Yes. Businesses can send WhatsApp marketing messages to opted-in customers and track message activity from the dashboard.",
  },
  {
    q: "Can I track WhatsApp message responses in the dashboard?",
    a: "Yes. The dashboard can track customer replies, message status, promotion usage, and lead progress.",
  },
  {
    q: "Can Instagram and Facebook comments be replied to automatically?",
    a: "Yes. The bot can automatically reply to comments on selected Instagram and Facebook reels or posts.",
  },
  {
    q: "Can the bot send automatic DM replies?",
    a: "Yes. When a customer comments or engages with a post, the bot can send an automatic DM with the next step or WhatsApp link.",
  },
  {
    q: "Can customers be moved from Instagram or Facebook to WhatsApp?",
    a: "Yes. Customers from reels, posts, comments, DMs, or ads can be guided to the AI WhatsApp chatbot.",
  },
  {
    q: "What happens after the customer enters WhatsApp?",
    a: "The AI WhatsApp chatbot can answer questions, share service details, collect enquiries, and support lead conversion automatically.",
  },
  {
    q: "Do you also run Meta Ads?",
    a: "Yes. Meta Ads can be run for Instagram reels, Facebook posts, and marketing creatives to increase reach and bring more leads into WhatsApp.",
  },
];

const DigitalMarketing = () => {
  pageTitle("WhatsApp Marketing");

  const [openIndex, setOpenIndex] = useState(0);

  const handleWhatsAppClick = () => {
    const phoneNumber = "6590059743"; // WhatsApp number (no '+' or spaces)
    const message =
      "Hello! I would like to know more about AI-Powered Digital Marketing services.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message,
    )}`;
    window.open(url, "_blank");
  };

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <>
      <HeaderOne />

      <div
        className="ai-overlay-wrapper-solutions"
        style={{ backgroundImage: `url(${AiInvoiceBanner})` }}
      >
        <div className="ai-overlay">
          <div className="ai-overlay-center-project-text-solutions">
            <h2 className="ai-overlay-project">
              AI-Powered WhatsApp <br />
              Marketing
            </h2>
          </div>

          <div className="siw-hero-price-box-sol">
            <h3>From SGD 100/month</h3>

            <button
              onClick={handleWhatsAppClick}
              className="theme-btn theme-btn-one siw-hero-small-btn"
            >
              Start a Free Trial
            </button>
          </div>
        </div>
      </div>

      <section className="py-3 py-md-4">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7 d-flex">
              <div className="food-grey-box w-100">
                <h3 className="siw-project-heading pb-1">
                  AI WhatsApp Marketing with Meta Automation
                </h3>

                <p className="mb-0 siw-rpa-desc">
                  Our AI-Powered WhatsApp Marketing solution helps businesses
                  send targeted WhatsApp promotional messages to opted-in
                  customers and track message status, customer replies,
                  promotion usage, and lead movement from one dashboard.
                </p>

                <p className="siw-rpa-desc">
                  The solution also automates Instagram and Facebook engagement
                  by replying to comments, sending DM follow-ups, and guiding
                  interested customers from reels, posts, and Meta Ads into the
                  AI WhatsApp chatbot for instant enquiry handling and lead
                  conversion.
                </p>
              </div>
            </div>

            <div className="col-lg-5 d-flex">
              <div className="siw-shorts-wrapper w-100">
                <div className="row g-3">
                  {/* Short 2 */}
                  <div className="col-6">
                    <a
                      href="https://www.youtube.com/shorts/vAAu-RH2y8Y"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="siw-short-card"
                    >
                      <img
                        src="https://img.youtube.com/vi/vAAu-RH2y8Y/hqdefault.jpg"
                        alt="Instagram to WhatsApp Automation Video"
                        className="siw-short-thumbnail"
                      />
                      <div className="siw-short-play-btn">▶</div>
                    </a>
                  </div>
                  {/* Short 1 */}
                  <div className="col-6">
                    <a
                      href="https://www.youtube.com/shorts/25B34YljTRk"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="siw-short-card"
                    >
                      <img
                        src="https://img.youtube.com/vi/25B34YljTRk/hqdefault.jpg"
                        alt="AI WhatsApp Marketing Video"
                        className="siw-short-thumbnail"
                      />
                      <div className="siw-short-play-btn">▶</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-3 pt-md-0 pb-md-5 wafod-features-section">
        <div className="container">
          <h3 className="wafod-section-heading">Architecture</h3>

          <img
            src={Architecture}
            alt="Architecture"
            className="img-fluid mb-4"
            height="200"
          />

          <h3 className="wafod-section-heading">WhatsApp Marketing Workflow</h3>

          <img
            src={workflow}
            alt="WhatsApp Marketing Workflow"
            className="img-fluid mb-4 wa-workflow-img"
          />

          <div className="mb-5">
            <h3 className="wafod-section-heading">Key Features</h3>
          </div>

          <div className="row g-4 justify-content-center">
            {featureCards.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="food-feature-card wafod-feature-card h-100">
                  <div className="food-feature-icon wafod-feature-icon">
                    <i className={item.icon}></i>
                  </div>

                  <h5 className="wafod-card-title">{item.title}</h5>

                  <p className="mb-0 wafod-card-text">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-3 py-md-5 wafod-results-section">
        <div className="container">
          {/* Subscription tiers */}
          <div className="siw-subscription-block">
            <h2>WhatsApp Marketing tiers</h2>

            <div className="siw-subscription-table-wrap">
              <table className="siw-subscription-table">
                <thead>
                  <tr>
                    <th>Price</th>
                    <th>WhatsApp Marketing</th>
                    <th>Support</th>
                    <th>Integrations</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>$30</td>
                    <td>~100 messages</td>

                    <td>✓</td>
                    <td>—</td>
                  </tr>

                  <tr>
                    <td>$300</td>
                    <td>~1,000 messages</td>

                    <td>✓</td>
                    <td>—</td>
                  </tr>

                  <tr>
                    <td>$900</td>
                    <td>~3,000 messages</td>

                    <td>✓</td>
                    <td>✓</td>
                  </tr>

                  <tr>
                    <td>Custom</td>
                    <td>Custom volume</td>

                    <td>✓</td>
                    <td>✓</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="my-4">
            <h3 className="wafod-section-heading-light pb-1">
              Business Impact
            </h3>
          </div>

          <div className="siw-subscription-table-wrap">
            <table className="siw-subscription-table">
              <thead>
                <tr>
                  <th>Metric</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>

              <tbody>
                {resultsData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.metric}</td>
                    <td>{row.before}</td>
                    <td>{row.after}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="pt-3 pb-2 py-md-4 wafod-faq-section">
        <div className="container">
          <div className="mb-5">
            <h3 className="wafod-section-heading">Common Questions</h3>
          </div>

          <div className="accordion wafod-accordion">
            {faqs.map((item, index) => (
              <div
                className="accordion-item food-accordion-item wafod-accordion-item mb-3"
                key={index}
              >
                <h2 className="accordion-header wafod-accordion-header">
                  <button
                    type="button"
                    className={`accordion-button food-accordion-btn wafod-accordion-btn ${
                      openIndex !== index ? "collapsed" : ""
                    }`}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                  >
                    {item.q}
                  </button>
                </h2>

                <div
                  className={`accordion-collapse collapse ${
                    openIndex === index ? "show" : ""
                  }`}
                >
                  <div className="accordion-body wafod-accordion-body">
                    {item.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FooterOne />
    </>
  );
};

export default DigitalMarketing;
